<ng-container>
  <jb-date-picker
    class="two-month"
    *ngIf="vm$ | async; let vm"
    [dateFormat]="vm.dateDisplayFormat"
    [hasAvailability]="
      vm.showSchedule
        | shouldAutoLoad: isMobile : appConfigService.bookerCalendarAutoLoad
    "
    [isLoadedMonthly]="
      vm.showSchedule
        | shouldAutoLoad: isMobile : appConfigService.bookerCalendarAutoLoad
    "
    [intersectionDebounce]="intersectionDebounce"
    [intersectionThreshold]="intersectionThreshold"
    (monthVisibilityChange)="monthVisibilityChange.emit($event)"
    [shouldFlipVertically]="false"
    [isTwoMonthDatePicker]="true"
    [minDate]="vm.minDate"
    [maxDate]="vm.maxDate"
    [placement]="vm.placement"
    [closeOnDateSelected]="!vm.keepCalendarOpen"
    [isDayTextHidden]="!vm.showPricing"
    (flyoutStateChanging)="handleFlyoutStateChanging($event)"
    [calendarLabelDone]="vm.content.doneLabel ? vm.content.doneLabel : 'Done'"
    [calendarLabelReset]="
      vm.content.resetLabel ? vm.content.resetLabel : 'Reset'
    "
  >
    <!-- Departure date input -->
    <jb-form-field-container
      [ngClass]="{
        'jb-invalid': vm.showValidationErrors && startDateControl.invalid,
        'w-50': !(isOneWay$ | async)
      }"
      class="lh-copy flex-grow-1"
    >
      <jb-date-picker-input
        #datePickerInput
        (focus)="onStartDateFocused()"
        class="bg-white"
        [label]="vm.content.departureLabel"
        [formControl]="startDateControl"
        [dateInputFormats]="vm.dateInputFormats"
        (valueChange)="handleStartDateChange($event)"
        data-qaid="departDateInput"
      >
      </jb-date-picker-input>

      <jb-error
        *ngIf="!(isOneWay$ | async)"
        [showErrorIf]="
          !!vm.departErrorMessage &&
          (startDateControl.invalid || departureControl?.invalid)
        "
      >
        <div>
          <span aria-hidden="true">{{ vm.departErrorMessage }}</span>
          <jb-sr-only>Error: {{ vm.departErrorMessage }}</jb-sr-only>
        </div>
      </jb-error>

      <ng-container *ngIf="isOneWay$ | async">
        <jb-error
          [showErrorIf]="!!vm.departErrorMessage && startDateControl.invalid"
          *ngIf="
            !!vm.departErrorMessage && startDateControl.invalid;
            else controlErrorStart
          "
        >
          <div>
            <span aria-hidden="true">{{ vm.departErrorMessage }}</span>
            <jb-sr-only>Error: {{ vm.departErrorMessage }}</jb-sr-only>
          </div>
        </jb-error>
      </ng-container>

      <ng-template #controlErrorStart>
        <jb-error
          *ngFor="let error of startDateControl.errors | keyvalue"
          [forError]="error.key"
          [showErrorIf]="vm.showValidationErrors"
        >
          <div>
            <span aria-hidden="true">{{ error.value }}</span>
            <jb-sr-only>Error: {{ error.value }}</jb-sr-only>
          </div>
        </jb-error>
      </ng-template>
    </jb-form-field-container>

    <!-- Return date input -->
    <jb-form-field-container
      *ngIf="!(isOneWay$ | async)"
      class="w-50 ml1 lh-copy"
      [ngClass]="{
        'jb-invalid': vm.showValidationErrors && endDateControl.invalid
      }"
    >
      <jb-date-picker-input
        #datePickerInput
        (focus)="onEndDateFocused()"
        class="bg-white"
        [label]="vm.content.returnLabel"
        [formControl]="endDateControl"
        [dateInputFormats]="vm.dateInputFormats"
        (valueChange)="handleEndDateChange($event)"
        (flyoutStateChanging)="handleFlyoutStateChanging($event)"
        data-qaid="returnDateInput"
      >
      </jb-date-picker-input>

      <jb-error
        [showErrorIf]="
          !!vm.returnErrorMessage &&
          (endDateControl.invalid || returnControl?.invalid)
        "
      >
        <div>
          <span aria-hidden="true">{{ vm.returnErrorMessage }}</span>
          <jb-sr-only>Error: {{ vm.returnErrorMessage }}</jb-sr-only>
        </div>
      </jb-error>
    </jb-form-field-container>

    <jb-calendar-legal-message>
      <p class="body">{{ vm.message }}</p>
    </jb-calendar-legal-message>

    <jb-calendar-legal-message [class.body]="vm.showSchedule">
      <p class="body">{{ vm.seasonalRouteMessage }}</p>
    </jb-calendar-legal-message>

    <jb-calendar-legal-message *ngIf="!vm.showSchedule">
      <p class="body" *ngIf="vm.content?.settings as settings">
        {{ settings.messagePreDate }}
        {{ vm.maxDate | jbDate: 'MMM d, yyyy' }}
        {{ settings.messagePostDate }}
      </p>
    </jb-calendar-legal-message>

    <jb-calendar-actions-message *ngIf="totalCost?.amount">
      <div class="core-blue">
        <b *ngIf="!totalCost.tax">
          {{
            totalCost.amount
              | dotCurrency: totalCost.currencyCode : 'symbol' : '1.2'
          }}
        </b>
        <ng-container *ngIf="totalCost.tax">
          <b>
            <span>
              {{ (totalCost.amount | jbPointsPipe: { small: false }) + ' pts' }}
            </span>
            <span>
              +
              {{
                totalCost.tax
                  | dotCurrency: totalCost.currencyCode : 'symbol' : '1.2'
              }}
            </span>
          </b>
        </ng-container>
      </div>
      <div class="break-word">
        {{ !(isOneWay$ | async) ? 'roundtrip/person' : 'one-way/person' }}
      </div>
    </jb-calendar-actions-message>

    <!-- header controls inside mobile calendar -->
    <jb-activity-header *ngIf="showTripTypeMobile" (backButtonClicked)="back()">
      <jb-activity-header-controls>
        <ng-content></ng-content>
      </jb-activity-header-controls>
      <jb-activity-header-buttons>
        <button
          jbButton
          tabindex="0"
          theme="minimal"
          size="small"
          (click)="resetDates()"
        >
          Reset
        </button>
      </jb-activity-header-buttons>
    </jb-activity-header>
    <!-- end of header controls  -->
  </jb-date-picker>
</ng-container>
